<template>
  <div class="container" @click="flagOn">
    <section id="editContent" class="columnContainer settingPage">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.reservation}} &#8250; {{info.space}}</h1>
        <Item
          :locale="locale"
          :lang="lang"
          :info="info"
          @updateAdditionalInfo="info.additionalInfo = $event" />
      </div>
    </section>
    <div id="setContent">
      <Setting
        :locale="locale"
        :lang="lang"
        :info="info"
        @isLoadPage="isLoadPage"
        @save="save" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment/moment'
import UNIQUE from '@/common/unique.js'
import regExp from '@/common/regExp'
import LANG from '@/common/lang'
import Item from '@/components/Reservation/Item'
import Setting from '@/components/Reservation/SettingItem'

export default {
  name: 'Reservation',
  components: {
    Item,
    Setting
  },
  props: [
    'locale',
    'id',
    'isIdle'
  ],
  computed: {
    ...mapGetters({
      getSetting: 'setting/getData'
    }),
    lang () {
      return this.getSetting.lang
    },
    newItem () {
      return !this.id
    },
    section () {
      const info = this.info.section
      let result = {}
      function getPlace (arr) {
        let place = {}
        arr.forEach(function (x) {
          place[x.id] = x
          delete place[x.id].id
        })
        return place
      }
      info.forEach(function (x) {
        result[x.id] = {
          ...x,
          place: getPlace(x.place)
        }
        delete result[x.id].id
      })
      return result
    }
  },
  watch: {
    '$route' (to, from, next) {
      this.setItem()
    }
  },
  created () {
    window.addEventListener('beforeunload', (e) => {
      if (this.dirtyFlag) {
        e.returnValue = '\\o/'
      }
    })
    this.init()
  },
  mounted () {
    this.setItem()
  },
  beforeRouteLeave (to, from, next) {
    const tryLogout = to.name === 'login'
    if (this.dirtyFlag && !this.isIdle && !tryLogout) {
      if (window.confirm(`${this.locale.confirm_leave}\n${this.locale.warn_leave}`)) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  data () {
    return {
      dirtyFlag: false,
      info: {
        id: '',
        space: 'New Item',
        autoAssign: true,
        name: this.$store.getters['setting/getLangValues'](),
        infoTxt: this.$store.getters['setting/getLangValues'](),
        disabled: false,
        cancel: true,
        cancelDay: 1,
        cancelTime: 60,
        allowedToday: false,
        possibleUpTo: false,
        possibleUpToTime: 60,
        range: 2,
        dayOfWeek: [
          { id: 'mon', available: true, weekday: 2 },
          { id: 'tue', available: true, weekday: 3 },
          { id: 'wed', available: true, weekday: 4 },
          { id: 'thu', available: true, weekday: 5 },
          { id: 'fri', available: true, weekday: 6 },
          { id: 'sat', available: true, weekday: 7 },
          { id: 'sun', available: true, weekday: 1 }
        ],
        disabledDays: [],
        time: [],
        section: [],
        bookerName: true,
        bookerTel: true,
        bookerEmail: false,
        linkedPage: false,
        linkInfo: {
          id: '',
          type: 'page',
          pageId: '',
          target: false,
          url: this.$store.getters['setting/getLangValues']()
        },
        limitPer: {
          active: false,
          type: 'night', // ota, night
          limit: 1
        },
        limitPerDay: false, // 이미 예약일인 경우 추가예약?
        multiple: false,
        availableType: 'ota', // 예약자 타입은 하위 값을 포함하는 개념 ota < rid < visitor / package: 특정 패키지 이용자
        additionalInfo: [], // 예약자 추가정보 (필수입력 외 추가 정보)
      }
    }
  },
  methods: {
    init () {
      this.dirtyFlag = false
    },
    setItem () {
      function getHhmm (string) {
        const hh = string.substr(0, 2)
        const mm = string.substr(2, 2)
        return moment().set({ hour: hh, minute: mm }).toISOString()
      }
      function getTime (arr) {
        const result = arr.map(x => {
          return {
            from: getHhmm(x.from),
            to: getHhmm(x.to),
            label: x.label || this.$store.getters['setting/getLangValues']()
          }
        })
        return result
      }
      if (!this.newItem) {
        const id = this.$route.params.id
        this.$store.commit('onLoading', true)
        this.$store.dispatch('reservation/getReservation', id).then((res) => {
          if (res) {
            this.info = {
              ...this.info,
              ...res,
              ...(res.time && res.time.length) && {
                time: getTime(res.time)
              }
            }
            // 구버전 설정(예약제한값) 변경
            if (res.limitPerOta && !res.limitPer) {
              this.info.limitPer.active = true
              this.info.limitPer.type = 'ota'
              this.info.limitPer.limit = 1
            }
            if (res.preArrival && !res.limitPer) {
              this.info.availableType = res.preArrival && 'visitor'
            }
          } else {
            alert(this.locale.alert_reservation_item_error)
            this.$router.push({ name: 'reservationList', params: { paging: 1 } })
          }
          this.$store.commit('onLoading', false)
        })
      } else {
        const siteid = this.$store.state.authentication.userInfo.siteid
        this.info.id = `${siteid}.${UNIQUE.mid()}`
      }
    },
    setAdditionalInfo (data) {

    },
    isLoadPage (isLinked) {
      this.info.linkedPage = isLinked
    },
    flagOn () {
      this.dirtyFlag = true
    },
    validateOnSave () {
      if (!regExp.replaceAllEmpty(this.info.space).length) {
        // 제목을 입력해주세요.
        alert(this.locale.validate_reservation_title)
        return false
      } else if (!this.info.section.length) {
        // 예약공간(섹션)을 하나 이상 추가해 주세요.
        alert(this.locale.validate_reservation_blank_section)
        return false
      } else if (!this.info.time.length) {
        // 예약시간을 하나 이상 추가해 주세요.
        alert(this.locale.validate_reservation_blank_time)
        return false
      } else {
        return window.confirm(`${this.locale.confirm_reservation_change_apply}\n${this.locale.confirm_reservation_change_neworder}`)
        // 변경된 설정값은 신규 예약부터 반영됩니다.
      }
    },
    save () {
      function setTime (arr) {
        const result = arr.map(x => { // moment 객체에서 시간만 추출
          const from = moment(x.from).format('HHmm')
          const to = moment(x.to).format('HHmm')
          return {
            from: from,
            to: to,
            label: x.label
          }
        }).filter((t, index, self) => ( // 중복된 시간이 있는지 체크
          index === self.findIndex((f) => {
            return f.from === t.from && f.to === t.to
          })
        )).sort((a, b) => Number(`${a.from}${a.to}`) - Number(`${b.from}${b.to}`))
        return result
      }
      if (this.validateOnSave()) {
        const info = this._.cloneDeep(this.info)
        const data = {
          property: this.info.id,
          payload: {
            ...info,
            ...(info.time && info.time.length) && {
              time: setTime(info.time)
            }
          }
        }
        this.$store.commit('onLoading', true)
        this.$store.dispatch('reservation/setReservation', data).then((res) => {
          alert(this.locale.complete_save)
          this.dirtyFlag = false
          this.$store.commit('onLoading', false)
          if (this.newItem) {
            this.$router.replace({ name: 'reservationItem', params: { id: data.property } })
          } else {
            this.setItem()
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.innerColumn {
  display: flex;
  flex-direction: column;
}
</style>
